export * from './DiamondFilled';